import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";
import { IPurchaseOrder } from "redux/reducers/models/purchaseOrder";

interface IGetPurchaseOrder {
    id?: number;
    vendor_id?: number;
    status?: "draft" | "finalized";
    statuses?: Array<string>;
    extended?: boolean;
    search?: string;
    offset?: number;
    limit?: number;
    year?: number;
}

interface IPostPurchaseOrder {
    vendor_id: number | null;

    status: string;
    po_number: string;

    // Bill To
    bill_to_name: string;
    bill_to_address_line: string;
    bill_to_city: string;
    bill_to_province: string;
    bill_to_postal: string;
    bill_to_country: string;

    // Ship To
    ship_to_name: string;
    ship_to_address_line: string;
    ship_to_city: string;
    ship_to_province: string;
    ship_to_postal: string;
    ship_to_country: string;

    // Vendor
    vendor_name: string;
    vendor_address_line: string;
    vendor_city: string;
    vendor_province: string;
    vendor_postal: string;
    vendor_country: string;
    vendor_contact_name: string | null;
    vendor_email: string | null;
    vendor_phone: string | null;

    notes: string | null;
}

interface IPutPurchaseOrder {
    id: number;
    vendor_id?: number | null;

    status?: string;
    po_number?: string;

    // Bill To
    bill_to_name?: string;
    bill_to_address_line?: string;
    bill_to_city?: string;
    bill_to_province?: string;
    bill_to_postal?: string;
    bill_to_country?: string;

    // Ship To
    ship_to_name?: string;
    ship_to_address_line?: string;
    ship_to_city?: string;
    ship_to_province?: string;
    ship_to_postal?: string;
    ship_to_country?: string;

    // Vendor
    vendor_name?: string;
    vendor_address_line?: string;
    vendor_city?: string;
    vendor_province?: string;
    vendor_postal?: string;
    vendor_country?: string;
    vendor_contact_name?: string | null;
    vendor_email?: string | null;
    vendor_phone?: string | null;

    notes?: string | null;
}

// Purchase order
export async function GetPurchaseOrder(params: IGetPurchaseOrder, useGlobalLoader: boolean, token?: CancelToken) {
    return await APIGet<Array<IPurchaseOrder>>(APIUrl(AdminType.FacilityAdmin, "/purchase-order"), params, useGlobalLoader, token);
}

export async function PostPurchaseOrder(params: IPostPurchaseOrder, useGlobalLoader: boolean) {
    return await APIPost<IPurchaseOrder>(APIUrl(AdminType.FacilityAdmin, "/purchase-order"), params, useGlobalLoader);
}

export async function PutPurchaseOrder(params: IPutPurchaseOrder, useGlobalLoader: boolean) {
    return await APIPut<IPurchaseOrder>(APIUrl(AdminType.FacilityAdmin, "/purchase-order"), params, useGlobalLoader);
}

export async function PutPurchaseOrderClose(params: {id: number}, useGlobalLoader: boolean) {
    return await APIPut<IPurchaseOrder>(APIUrl(AdminType.FacilityAdmin, "/purchase-order/close"), params, useGlobalLoader);
}

export async function DeletePurchaseOrder(params: {id: number}, useGlobalLoader: boolean) {
    return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/purchase-order"), params, useGlobalLoader);
}

export async function GetPurchaseOrderDownload(params: {id: number}, useGlobalLoader: boolean) {
    return await APIGet(APIUrl(AdminType.FacilityAdmin, "/purchase-order/download"), params, useGlobalLoader);
}

// Purchase order items
export async function PostPurchaseOrderItems(params: {purchase_order_id: number; variants: Array<{variant_id: number; quantity: number; unit_cost: number; notes?: number;}>}, useGlobalLoader: boolean) {
    return await APIPost<IPurchaseOrder>(APIUrl(AdminType.FacilityAdmin, "/purchase-order/item"), params, useGlobalLoader);
}

export async function PutPurchaseOrderItems(params: {purchase_order_id: number; items: Array<{id: number; quantity: number; unit_cost: number; notes?: string;}>}, useGlobalLoader: boolean) {
    return await APIPut<IPurchaseOrder>(APIUrl(AdminType.FacilityAdmin, "/purchase-order/item"), params, useGlobalLoader);
}

// Adds to quantity_received. To override quantity_received, use PutPurchaseOrderItems
export async function PutQuantityReceivedPurchaseOrderItems(params: {purchase_order_id: number; items: Array<{id: number; quantity_received: number;}>}, useGlobalLoader: boolean) {
    return await APIPut<IPurchaseOrder>(APIUrl(AdminType.FacilityAdmin, "/purchase-order/item/quantity-received"), params, useGlobalLoader);
}

export async function DeletePurchaseOrderItem(params: {id: number}, useGlobalLoader: boolean) {
    return await APIDelete<IPurchaseOrder>(APIUrl(AdminType.FacilityAdmin, "/purchase-order/item"), params, useGlobalLoader);
}